import React from 'react';
import MaterialTableCell from '@material-ui/core/TableCell';
import { TDataInterface, TTableCell } from './index.types';
import { TableCellStyled } from './index.styled';

const TableCell = <TRowData extends TDataInterface>({
    value,
    cellValue,
    rowData,
    className,
    onClickCell,
}: TTableCell<TRowData>) => {
    const { width, title, render: CellRenderComp } = value || {};

    return (
        <MaterialTableCell
            className={className}
            width={width}
            key={`cell_${title}`}
            onClick={onClickCell}
        >
            <TableCellStyled>
                {CellRenderComp ? (
                    <CellRenderComp value={cellValue} rowData={rowData} />
                ) : (
                    cellValue
                )}
            </TableCellStyled>
        </MaterialTableCell>
    );
};

export default TableCell;
